<template>
    <div id="create-campaign">
        <div>
            <v-expansion-panels>
                <v-expansion-panel style="background-color: #f5f5f5;">
                    <v-expansion-panel-header>
                        <div class="table-title">
                            Utiliser un modèle d'e-mails
                        </div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <v-alert text class="mb-5" type="info" border="right" colored-border>
                            Pour faciliter la saisie des contenus d'e-mails envoyés aux professionnels, vous pouvez
                            créer un modèle d'e-mail <router-link to="/configuration/email-template" target="_blank">ici</router-link>
                            .<br>
                            Vous pourrez ensuite le sélectionner dans la liste ci-dessous pour précharger les champs
                            <span class="email-content-span">Objet</span>,
                            <span class="email-content-span">Première partie de l'e-mail</span> et
                            <span class="email-content-span">Dernière partie de l'e-mail</span>.
                        </v-alert>

                        <div class="d-flex mb-5">
                            <div class="mt-auto mb-auto mr-3">
                                <v-label>Charger un modèle d'e-mail</v-label>
                            </div>

                            <v-select hide-details outlined :items="templates" @input="loadTemplate" item-text="name"
                                return-object style="padding-top: 0!important;">
                            </v-select>

                            <div class="ml-2 mt-auto mb-auto">
                                <v-tooltip bottom >
                                    <template v-slot:activator="{ on }">
                                        <v-btn v-on="on" icon>
                                            <v-icon class="m-2"
                                                    id="updateBtn"
                                                    @click="getTemplates">
                                                refresh
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                  <span>Rafraichir la liste de vos modèles d'e-mails</span>
                                </v-tooltip>
                            </div>
                        </div>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>

            <hr style="margin-top: 30px; margin-bottom: 20px">
        </div>

        <h3><span class="required">Émetteur</span></h3>
        <v-select :items="senders" outlined style="padding-top: 0 !important;" class="no-details mb-5"
            item-text="emailable.email" v-model="sender" return-object>
            <v-tooltip slot="append-outer" bottom>
                <template v-slot:activator="{ on }">
                    <v-icon v-on="on">help</v-icon>
                </template>
                <span>Adresse E-mail et Nom d'expéditeur que verront vos prestataires.</span>
            </v-tooltip>

            <template slot="selection" slot-scope="data">
                <span v-if="data.item.name !== null" class="pr-2">
                    {{ data.item.name }}
                </span>
                <span>({{ data.item.emailable.email }})</span>
            </template>
            <template slot="item" slot-scope="data">
                <span v-if="data.item.name !== null" class="pr-2">
                    {{ data.item.name }}
                </span>
                <span>({{ data.item.emailable.email }})</span>
            </template>
        </v-select>

        <h3><span class="required">Destinataire</span></h3>
        <v-combobox outlined style="padding-top: 0 !important;" v-model="contact" :items="contacts"
            no-data-text="Pas de contact associé à cette fiche" item-text="email" return-object>
        </v-combobox>

        <h3><span class="required">Objet</span></h3>

        <v-text-field background-color="white" style="padding-top: 0 !important;" outlined v-model="subject"
            class="subject-input">
        </v-text-field>

        <v-alert text class="mb-5 mt-5" type="info" v-if="account.tis_type.code === 'DAHUB_QUEBEC'">
            Pour générer un objet en fonction du nom ou du type de prestataire, vous pouvez utiliser le tags suivant
            :<br>
            <b>#nom#</b> : le nom de la fiche<br>
        </v-alert>

        <v-alert text class="mb-5 mt-5" type="info" v-else>
            Pour générer un objet en fonction du nom ou du type de prestataire, vous pouvez utiliser les tags suivants
            :<br>
            <b>#nom#</b> : le nom de la fiche<br>
            <b>#type#</b> : le type de la fiche (ex: Restauration)
        </v-alert>

        <h3><span class="required">Première partie de l'e-mail</span></h3>
        <ckeditor :editor="editor" v-model="firstPartEmail"></ckeditor>

        <div class="text-center valid-button">
            <form-link :generated="true" :name="provider.last_not_drafted_version.name"></form-link>
        </div>

        <h3>Dernière partie de l'e-mail</h3>
        <ckeditor :editor="editor" v-model="lastPartEmail"></ckeditor>

        <div :class="{ 'disabled-box': sender === null }">
            <h3 class="mt-5" style="margin-bottom: 0 !important;">Signature</h3>
            <div class="d-flex align-items-center">
                <div class="mt-auto mb-auto">
                    <v-checkbox v-model="generateSignature" label="Générer automatiquement la signature" hide-details
                        class="mr-3 mt-0 pt-0">
                    </v-checkbox>
                </div>

                <div class="mt-auto mb-auto">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-icon v-on="on">help</v-icon>
                        </template>
                        <span>
                            En cochant cette case, la signature de l'émetteur sera utilisée (voir exemple ci-contre)
                        </span>
                    </v-tooltip>
                </div>
            </div>

            <div class="mt-5 valid-button mb-0" v-if="generateSignature">
                <div class="title-valid-button">Signature</div>

                <div class="mt-3">
                    <v-progress-circular indeterminate color="primary" v-if="loadSignature"></v-progress-circular>
                    <div v-else v-html="signature"></div>
                </div>
            </div>

            <div v-else class="mt-5">
                <ckeditor :editor="editor" v-model="signature"></ckeditor>
            </div>
        </div>


        <div class="mt-5 mb-5 valid-button" v-if="!isValid">

            <div class="title-valid-button">
                <v-icon color="warning">warning</v-icon> Informations requises
            </div>

            <div class="mt-3">
                <div v-if="sender === null">
                    L'émetteur est requis.
                </div>

                <div v-if="contact === null">
                    Le destinataire est requis.
                </div>

                <div v-if="subject === ''">
                    Le sujet est requis.
                </div>

                <div v-if="firstPartEmail === null">
                    La 1ère partie de l'email est requise.
                </div>

                <div v-if="lastPartEmail === null">
                    La 2nd partie de l'email est requise.
                </div>
            </div>
        </div>

        <div class="d-flex justify-content-end gap-20 mb-5 mt-5">
            <v-btn class="custom-button-primary" outlined @click="preview = true">
                <v-icon class="mr-2">remove_red_eye</v-icon> Voir l'e-mail
            </v-btn>
            <v-btn class="default-button" @click="sendEmail"
            :disabled="sender === null || contact === null || subject === '' ||
             firstPartEmail === null || lastPartEmail === null">
                <v-icon left>send</v-icon> Envoyer
            </v-btn>
        </div>

        <v-dialog v-model="preview" persistent max-width="600px" content-class="preview-modal">
            <v-card>
                <v-card-title>
                    <div class="w-100 d-flex justify-content-between align-items-center">
                        <span class="headline">Prévisualisation de l'email</span>
                        <v-icon @click="preview = false">clear</v-icon>
                    </div>
                </v-card-title>
                <v-card-text>
                    <div class="mb-4">
                        <b>{{ generatedSubject }}</b>
                    </div>

                    <div v-html="firstPartEmail" class="mb-3"></div>
                    <div class="valid-button text-center">
                        <form-link :name="provider.last_not_drafted_version.name"></form-link>
                    </div>
                    <div v-html="lastPartEmail"></div>
                    <div class="mt-5" v-html="signature"></div>
                </v-card-text>

                <!-- <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="error" @click="preview = false">Fermer</v-btn>
                </v-card-actions> -->
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { mapState } from "vuex"
import ClassicEditor from '../../../../plugins/ckeditor'
import FormLink from "@/components/campaign/cmaj/FormLink"

export default {
    name: "SimpleEmail",
    components: { FormLink },
    props: ['contacts', 'provider', 'templates'],
    data() {
        return {
            editor: ClassicEditor,
            sender: null,
            contact: null,
            subject: '',
            firstPartEmail: null,
            lastPartEmail: null,
            generateSignature: false,
            loadSignature: false,
            signature: null,
            preview: false,
            senders: []
        }
    },
    methods: {
        initFirstPartEmail() {
            let text = "<p>Cher(e) partenaire,</p>" +
                "<p>Nous vous sollicitons pour mettre à jour vos informations diffusées sur notre site internet ainsi que dans nos points d'accueil. " +
                "Au moyen du questionnaire accessible via le bouton ci-dessous, nous vous invitons à mettre à jour vos informations afin de renseigner au mieux nos visiteurs.</p>"

            this.firstPartEmail = text
        },
        initLastPartEmail() {
            let text = "<p>Nous restons disponibles pour vous accompagner dans la mise à jour de vos informations.</p>"

            this.lastPartEmail = text
        },
        initSubject() {
            let text = "Mise à jour de vos informations pour #nom# (#type#)"

            if(this.account.tis_type.code === 'DAHUB_QUEBEC') {
                text = "Mise à jour de vos informations pour #nom#"
            }

            this.subject = text
        },
        getSignature() {
            if (this.sender !== null) {
                this.loadSignature = true

                this.$http.get('auth/user/signature/' + this.sender.id).then(res => {
                    this.signature = res.body.data.signature

                    this.loadSignature = false
                })
            }
        },
        sendEmail() {
            let payload = {
                providerId: this.provider.id,
                senderId: this.sender.id,
                contact: this.contact,
                subject: this.subject,
                firstPartEmail: this.firstPartEmail,
                lastPartEmail: this.lastPartEmail,
                fieldIds: this.getFieldIds(),
                signature: this.signature,
                editedTabulations: this.editedTabulations,
                txtIntro: this.txtIntro,
            }

            this.$global.loading = true

            this.$http.post('auth/webform/send', payload).then(res => {
                if (res.body.success) {
                    this.$global.$emit('close-update-modal')
                    this.$global.$emit('reload-summary')
                }

                this.$global.loading = false
            })
        },
        getFieldIds() {
            let fieldsArray = Object.values(this.selectedFields)
            fieldsArray = [].concat.apply([], fieldsArray)

          return fieldsArray.map(field => {
            return {
              new_title: field.new_title,
              help_description: field.help_description,
              id: field.field_id,
              required: field.required,
            }
          })
        },
        loadTemplate(template) {
            this.subject = template.subject
            this.firstPartEmail = template.part1
            this.lastPartEmail = template.part2
        },
        getTemplates() {
            let btn = document.getElementById('updateBtn')

            if (btn) {
                btn.classList.add('fa-spin')
            }

            this.$http.get('auth/account/email-templates').then(res => {
                this.templates = res.body.data.templates

                if (btn) {
                    setTimeout(() => {
                        btn.classList.remove('fa-spin')
                    }, 500)
                }
            })
        },
    },
    computed: {
        ...mapState('account', ['account', 'token']),
        ...mapState('createCmaj', ['selectedFields', 'editedTabulations', 'txtIntro',]),
        generatedSubject() {
            let subject = this.subject

            subject = subject.replace('#nom#', this.provider.last_not_drafted_version.name)
            subject = subject.replace('#type#', this.provider.last_not_drafted_version.category.label)

            return subject
        },
        isValid() {
            return this.sender !== null &&
                this.contact !== null &&
                this.firstPartEmail !== null &&
                this.lastPartEmail !== null &&
                this.subject !== ''
        }
    },
    watch: {
        generateSignature() {
            if (this.generateSignature) {
                this.getSignature()
            }
        },
        contacts() {
            if (this.contacts.length) {
                this.contact = this.contacts[0]
            }
        },
    },
    mounted() {
        this.senders = this.account.senders.filter(sender => sender.delivery === 'SUCCESS')
    },
    created() {
        if (this.account.senders.length) {
            this.sender = this.account.senders[0]
        }

        if (this.contacts.length) {
            this.contact = this.contacts[0]
        }

        this.initFirstPartEmail()
        this.initLastPartEmail()
        this.initSubject()

        this.getTemplates()

        this.editor.defaultConfig.simpleUpload.headers = {
            Authorization: 'Bearer ' + this.token
        }
    }
}
</script>